export const formatDateShort = (dateStr: string): string => {
  try {
    return new Date(dateStr).toLocaleDateString(undefined, {
      day: 'numeric',
      month: 'short'
    });
  } catch {
    return dateStr;
  }
};

export const formatDateWithYear = (dateStr: string): string => {
  try {
    return new Date(dateStr).toLocaleDateString(undefined, {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  } catch {
    return dateStr;
  }
};

export const formatDateLong = (dateStr: string): string => {
  try {
    return new Date(dateStr).toLocaleDateString(undefined, {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  } catch {
    return dateStr;
  }
};

export const formatKg = (kg: number): string => `${kg.toFixed(1)} kg`;

export const formatPercent = (value: number): string => `${Math.round(value * 100)}%`;

export const formatDays = (days: number): string => (days === 1 ? '1 day' : `${days} days`);

export const formatEur = (value: number): string => `€${Math.round(Math.abs(value)).toLocaleString()}`;

export const formatEurPerKg = (value: number): string => `€${value.toFixed(2)}/kg`;

export const formatKgDelta = (kg: number): string => `${kg >= 0 ? '+' : ''}${kg.toFixed(1)} kg`;
